import { NgModule } from "@angular/core";
import { LandingComponent } from "./landing.page";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { RouterModule } from "@angular/router";
import { NgImageSliderModule } from "ng-image-slider";
import { AuthHeaderComponent } from "src/app/shared/components/auth-header/auth-header.component";
import { UnauthFooterComponent } from "src/app/shared/components/unauth-footer/unauth-footer.component";
import { UnauthHeaderComponent } from "src/app/shared/components/unauth-header/unauth-header.component";
import { MatCardModule } from "@angular/material/card";
import { CarouselComponent } from "src/app/shared/components/carousel/carousel.component";

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    ReactiveFormsModule,
    MatInputModule,
    UnauthHeaderComponent,
    AuthHeaderComponent,
    UnauthFooterComponent,
    NgImageSliderModule,
    MatCardModule,
    CarouselComponent,
  ],
  exports: [LandingComponent],
  declarations: [LandingComponent],
})
export class LandingPageModule {}
